import React from 'react';

import BackgroundVideo from './BackgroundVideo';
import BackgroundImage from './BackgroundImage';
import BackgroundGradient from './BackgroundGradient';
import BackgroundColor from './BackgroundColor';

class Background extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      background_image_url: props.background_image_url,
      background_color: props.background_color,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to,
      video_texture: props.video_texture,
      videoname: props.videoname,
      video_url: props.video_url,
      widget_hide_background: props.widget_hide_background,
    };
  }

  render() {
    const {
      staticUrl,
      background_type,
      background_image_url,
      background_color,
      gradient_from,
      gradient_to,
      video_texture,
      videoname,
      video_url,
      widget_hide_background,
    } = this.props;

    return ( !widget_hide_background &&
      <div id="hu-background">
        <BackgroundVideo
          staticUrl={staticUrl}
          background_type={background_type}
          videoname={videoname}
          video_url={video_url}
        />
        <BackgroundImage
          staticUrl={staticUrl}
          background_type={background_type}
          background_image_url={background_image_url}
        />
        <BackgroundGradient
          background_type={background_type}
          gradient_from={gradient_from}
          gradient_to={gradient_to}
        />
        <BackgroundColor
          background_type={background_type}
          background_color={background_color}
        />
      </div>
    )
  }
}

export default Background;


// WEBPACK FOOTER //
// ./app/js/components/background/Background.js